module.exports = __webpack_public_path__ + "static/coinbtltd-cover-f40fc14625025ea39826b9428362e8ea.jpg";